import React from 'react'

function HeroParallax({children, img, height, overlay, classParallax, classHeight}) {
    // const double = (string)=>{
    //     const number = /[0-9]+/;
    //     const misure = /[^0-9]+/;
    //     const x = number.exec(string);
    //     const y = misure.exec(string);
    //     console.log(x[0]+y[0]);
    //     return (parseInt(x[0])*2)+y[0];
    // }
    
    return (
        <div style={{
            height: height ? height : "auto",
        }} className={classHeight}>
            <div style={{
                position: "relative",
                width: "100%",
                height: height ? height : "auto",
                display: "flex",
                background: overlay ? "rgba(0, 0, 0, 0.5)" : "",
                alignItems:"center",
                justifyContent:"center",
                textAling:"center"
            }} className={classHeight}>
                {children}
            </div>
            <div style={{
                position: "relative",
                background:`url(${img})`,
                bottom: height ? "800px" : "auto",
                backgroundRepeat:"no-repeat",
                backgroundPosition:"center",
                backgroundSize:"cover",
                height: height ? height : "auto",
                transform: "translateZ(-1px) scale(2.2)",
                zIndex:"-1",
            }} className={classParallax}>
            </div>
        </div>
    )
}

export default HeroParallax